import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { GiftCardSettings, UserGiftCard, UserPurchaseGiftCard } from '@zeus/shared';

export interface GiftCardState {
  toRedirect: string | null;
  isGiftCard: boolean;
  giftCardOpened: boolean;
  restaurantGiftCardSettings: GiftCardSettings | null;
  selectedGiftCard: UserGiftCard | null;
  isOnGiftCardPinScreen: boolean;
  userPurchaseGiftCard: UserPurchaseGiftCard | null;
}

const initialState: GiftCardState = {
  toRedirect: null,
  isGiftCard: false,
  giftCardOpened: false,
  restaurantGiftCardSettings: null,
  selectedGiftCard: null,
  isOnGiftCardPinScreen: false,
  userPurchaseGiftCard: null,
};

export const giftCardSlice = createSlice({
  name: 'giftCard',
  initialState,
  reducers: {
    updateGiftCardSettings: (state, action: PayloadAction<any>) => {
      for (const key in action?.payload) {
        (state as any)[key] = action?.payload[key];
      }
    },
    clearUserGiftCardData: (state) => {
      state.isOnGiftCardPinScreen = false;
      state.userPurchaseGiftCard = null;
      state.selectedGiftCard = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateGiftCardSettings, clearUserGiftCardData } = giftCardSlice.actions;

export default giftCardSlice.reducer;
